/**
 * These keys don't appear in UI.
 */
const exceptions = ['last-seen']

/** Updates the refreshing flag. */
function updateRefreshing (state) {
  const keys = Object.keys(state.requestCountByServiceName).filter(
    key => !exceptions.includes(key),
  )

  const totalOutstandingRequests = keys
    .map(key => state.requestCountByServiceName[key])
    .reduce((acc, next) => {
      return acc + next
    }, 0)
  state.refreshing = totalOutstandingRequests > 0
}

/** Updates the list of human readable service names that are refreshing. */
function updateHumanReadable (state) {
  const keys = Object.keys(state.requestCountByServiceName) || []
  if (keys.length === 0) {
    console.log('Nothing refreshing...')
    state.humanReadableRefreshState = ''
  }
  const stringMap = {
    'data-model': 'Buildings & Cameras',
    entitlements: 'Permissions',
    'frontend-faces': 'Faces',
    identities: 'Badges',
    'last-seen': 'Last Seen',
    history: 'History',
    credentials: 'Credential',
  }
  state.humanReadableRefreshState = keys
    .filter(
      key =>
        state.requestCountByServiceName[key] > 0 && !exceptions.includes(key),
    )
    .map(key => stringMap[key] || key)
}

export const RefreshModule = {
  state: {
    requestCountByServiceName: {},
    refreshing: false,
    humanReadableRefreshState: '',
  },
  getters: {
    refreshing: state => {
      return state.refreshing
    },
    humanReadableRefreshState: state => {
      return state.humanReadableRefreshState
    },
    isRefreshingService: state => {
      return service => {
        if (!state.refreshing) {
          return false
        }
        return (
          state.requestCountByServiceName[service] &&
          state.requestCountByServiceName[service] > 0
        )
      }
    },
  },
  mutations: {
    /**
     * Mark a service as refreshing.
     */
    incrementRequestCountForServiceNamed: (state, serviceName) => {
      // console.debug(`Checkpoint: mutations.js -> incrementRequestCountForServiceNamed(${serviceName}) called.`)
      let count = parseInt(state.requestCountByServiceName[serviceName])
      if (serviceName in state.requestCountByServiceName) {
        count += 1
      } else {
        count = 1
      }
      state.requestCountByServiceName[serviceName] = count
      updateRefreshing(state)
      updateHumanReadable(state)
      // console.time(timerLabelForService(serviceName, count))
    },
    decrementRequestCountForServiceNamed (state, serviceName) {
      // console.debug(`Checkpoint: mutations.js -> decrementRequestCountForServiceNamed(${serviceName}) called.`)
      const count = state.requestCountByServiceName[serviceName]
      if (count === 0) {
        // This is a bug. We are calling decrementRequestCountForServiceNamed too many times or incrementRequestCountForServiceNamed too few times.
        // console.log(
        //   `Error: '${serviceName}' already has 0 loading requests in flight.`
        // )
      } else {
        // console.timeEnd(timerLabelForService(serviceName, count))
        state.requestCountByServiceName[serviceName] = count - 1
      }
      updateRefreshing(state)
      updateHumanReadable(state)
    },
  },
}
